import { BaseAPI } from '@/lib/api';

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

export interface UpdateSettingsRequest {
  telegram_chat_id?: string | null;
}

export interface ProfileResponse {
  success?: boolean;
  message?: string;
  error?: string;
}

class ProfileAPI extends BaseAPI {
  // Смена пароля
  async changePassword(data: ChangePasswordRequest): Promise<ProfileResponse> {
    return this.makeRequest<ProfileResponse>('/api/profile/change-password', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // Обновление настроек профиля
  async updateSettings(data: UpdateSettingsRequest): Promise<ProfileResponse> {
    return this.makeRequest<ProfileResponse>('/api/profile/settings', {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }
}

export const profileAPI = new ProfileAPI();
